<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.03752 1.66797H13.9625C14.9282 1.66797 15.4111 1.66797 15.8005 1.80348C16.539 2.06044 17.1187 2.65729 17.3683 3.41752C17.5 3.81843 17.5 4.31551 17.5 5.30969V16.9798C17.5 17.695 16.6792 18.0745 16.1599 17.5993C15.8548 17.3201 15.3952 17.3201 15.0901 17.5993L14.6875 17.9677C14.1528 18.457 13.3472 18.457 12.8125 17.9677C12.2778 17.4785 11.4722 17.4785 10.9375 17.9677C10.4028 18.457 9.59717 18.457 9.0625 17.9677C8.52783 17.4785 7.72216 17.4785 7.1875 17.9677C6.65284 18.457 5.84716 18.457 5.3125 17.9677L4.90992 17.5993C4.60486 17.3201 4.14514 17.3201 3.84008 17.5993C3.32083 18.0745 2.5 17.695 2.5 16.9798V5.30969C2.5 4.31551 2.5 3.81843 2.63162 3.41752C2.88123 2.65729 3.46102 2.06044 4.19949 1.80348C4.58893 1.66797 5.07178 1.66797 6.03752 1.66797ZM5.83333 5.6263C5.48816 5.6263 5.20833 5.90613 5.20833 6.2513C5.20833 6.59648 5.48816 6.8763 5.83333 6.8763H6.25C6.59517 6.8763 6.875 6.59648 6.875 6.2513C6.875 5.90613 6.59517 5.6263 6.25 5.6263H5.83333ZM8.75 5.6263C8.40483 5.6263 8.125 5.90613 8.125 6.2513C8.125 6.59648 8.40483 6.8763 8.75 6.8763H14.1667C14.5118 6.8763 14.7917 6.59648 14.7917 6.2513C14.7917 5.90613 14.5118 5.6263 14.1667 5.6263H8.75ZM5.83333 8.54297C5.48816 8.54297 5.20833 8.8228 5.20833 9.16797C5.20833 9.51314 5.48816 9.79297 5.83333 9.79297H6.25C6.59517 9.79297 6.875 9.51314 6.875 9.16797C6.875 8.8228 6.59517 8.54297 6.25 8.54297H5.83333ZM8.75 8.54297C8.40483 8.54297 8.125 8.8228 8.125 9.16797C8.125 9.51314 8.40483 9.79297 8.75 9.79297H14.1667C14.5118 9.79297 14.7917 9.51314 14.7917 9.16797C14.7917 8.8228 14.5118 8.54297 14.1667 8.54297H8.75ZM5.83333 11.4596C5.48816 11.4596 5.20833 11.7395 5.20833 12.0846C5.20833 12.4298 5.48816 12.7096 5.83333 12.7096H6.25C6.59517 12.7096 6.875 12.4298 6.875 12.0846C6.875 11.7395 6.59517 11.4596 6.25 11.4596H5.83333ZM8.75 11.4596C8.40483 11.4596 8.125 11.7395 8.125 12.0846C8.125 12.4298 8.40483 12.7096 8.75 12.7096H14.1667C14.5118 12.7096 14.7917 12.4298 14.7917 12.0846C14.7917 11.7395 14.5118 11.4596 14.1667 11.4596H8.75Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'BillsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>